
import { Box, Typography } from '@mui/material';
import { useRef, useState } from 'react';
import { useEffect } from 'react';
import { getAccounts, postCreateAccount } from '../../../data/hikoAdmin';
import { hikoException } from '../../../utils/HikoAlert';
import AlertLoading from '../../navigation/AlertLoading';

import { useContext } from 'react';
import { MahiContext } from '../../state/MahiContext';
import { EditableAddNewAccount } from './EditableAddNewAccount';
import { AccountsList } from './AccountsList';
import { DebugBox } from '@northpowerdev/np-react-utils';


export default function AdminListAccounts() {

    const [pageLoading, setPageLoading] = useState(false)
    const [accountSaving, setAccountSaving] = useState(false)
    const [accounts, setAccounts] = useState()
    const mahiContext = useContext(MahiContext)

    const getAccountsCallCounter = useRef(0)

    useEffect(() => {

        let didCancel = false;

        /**
         * @returns 
         */
        const asyncGetAccounts = async () => {
            setPageLoading(true)
            try {
                console.log('AdminListAccounts COUNT calling getAccounts', getAccountsCallCounter.current++)
                const allAccounts = await getAccounts(mahiContext)
                console.log('AdminListAccounts getAccounts done', allAccounts)
                if (!didCancel) {
                    setAccounts(allAccounts)
                }
            } catch (e) {
                hikoException('Admin List Accounts Error', e)
            }
            if (!didCancel) {
                setPageLoading(false);
            }
        };

        console.log('AdminListAccounts useEffect() calling asyncGetAccounts');
        asyncGetAccounts();

        return (() => {didCancel = true})

    // lint expects mahiContext but this causes re-renders
    // eslint-disable-next-line
    }, []);

    /**
     * 
     * @param {{accountId:String, name:String, email:String, phone:String}} accountDetails
     */
    const handleAccountChanged = async (accountDetails) => {
        console.log('AdminListAccounts handleAccountChanged accountDetails', accountDetails)
        let isSuccess = false;
        setAccountSaving(true);
        let createAccountResponse = null;
        try {
            console.log('AdminListAccounts calling postCreateAccount')
            createAccountResponse = await postCreateAccount(mahiContext, accountDetails)
            console.log('AdminListAccounts postCreateAccount done - did not throw error createAccountResponse', createAccountResponse)
            isSuccess = true;
        } catch (e) {
            hikoException('Mahi Admin Failed To Create Account', e)
        } finally {
            console.log('AdminListAccounts finally')
            setAccountSaving(false);
        }

        if (isSuccess) {
            console.log('AdminListAccounts isSuccess true adding to list', createAccountResponse)
            const newAccounts = accounts.concat([createAccountResponse]);
            console.log('AdminListAccounts isSuccess true newAccounts', newAccounts)
            setAccounts(newAccounts)
        }

    }

    const handleAccountEditComplete = (accountDetails) => {
        // Update the accounts list, replacing the account that has been modified
        // so we can see our changes.
        console.log('handleAccountEditComplete accountDetails', accountDetails)
        const newAccounts = []
        for (let a of accounts) {
            if (a.accountId === accountDetails.accountId) {
                newAccounts.push(accountDetails)
            } else {
                newAccounts.push(a)
            }
        }
        setAccounts(newAccounts)
    }

    // const counter = useRef(0);
    // console.log('AdminListAccounts  COUNT, pageLoading, adminUsers', counter.current, pageLoading, adminUsers)

    return (
        <Box className="Page">
            {/* <p>Users render {counter.current++}</p> */}
            <h2 className="np-title">Accounts</h2>
            <Typography variant="body1" paragraph>
                Maintain the list of Network approved contractors with contact details and Salesforce Accout Id.
            </Typography>
            <Box>
            {
            pageLoading
            ?
                <AlertLoading spinner={pageLoading} />
            :
            <>
                <AccountsList accounts={accounts} onAccountEditComplete={handleAccountEditComplete} />
                {
                    accountSaving
                    ?
                    <AlertLoading spinner={accountSaving} />
                    :
                    <EditableAddNewAccount accountChanged={handleAccountChanged} />
                }
                <DebugBox>{JSON.stringify(accounts)}</DebugBox>
            </>
            }
            </Box>
        </Box>
    );
}

